import { OrganizationDetailsResponseDto } from '../../../../lib/interfaces/organisation';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../ui/components/ui/select';

export interface AssignmentSingleFormProps {
  organisation: OrganizationDetailsResponseDto;
  isSaving: boolean;
  onAssignedInternalUserChange: (belongsToUserId: string) => void;
  onAssignedRepresentativeUserChange: (belongsToUserId: string) => void;
}

/** The unchanged single assignment: one contact plus an optional representative for notifications. */
const AssignmentSingleForm = ({
  organisation,
  isSaving,
  onAssignedInternalUserChange,
  onAssignedRepresentativeUserChange
}: AssignmentSingleFormProps) => {
  const selectableUsers = organisation.selectableEntities.internalUsers;

  const assignedUserId = selectableUsers.find((user) => user.value === organisation.assignedInternalUserFullName)?._id ?? 'NONE';
  const representativeUserId = selectableUsers.find((user) => user.value === organisation.assignedRepresentativeUserFullName)?._id ?? 'NONE';

  return (
    <div className="flex max-w-[520px] flex-col gap-4">
      <div className="flex flex-col gap-[6px]">
        <label className="text-[12.5px] font-semibold text-[#888]">Ansprechpartner</label>
        <Select value={assignedUserId} onValueChange={onAssignedInternalUserChange} disabled={isSaving}>
          <SelectTrigger className="h-10 rounded-lg border border-[#D0D5DD] px-3 text-sm" selectIconVariant="styled">
            <SelectValue placeholder="Benutzer zuweisen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="NONE">Keinen Benutzer zuweisen</SelectItem>
            {selectableUsers.map((user) => (
              <SelectItem key={user._id} value={user._id}>
                {user.value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex flex-col gap-[6px]">
        <label className="text-[12.5px] font-semibold text-[#888]">Vertreter (temporäre Zuweisung für Benachrichtigungen)</label>
        <Select value={representativeUserId} onValueChange={onAssignedRepresentativeUserChange} disabled={isSaving}>
          <SelectTrigger className="h-10 rounded-lg border border-[#D0D5DD] px-3 text-sm" selectIconVariant="styled">
            <SelectValue placeholder="Kein Vertreter" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="NONE">Keinen Vertreter zuweisen</SelectItem>
            {selectableUsers.map((user) => (
              <SelectItem key={user._id} value={user._id}>
                {user.value}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default AssignmentSingleForm;
